module.exports = __webpack_public_path__ + "img/rosco.8ff11a17.png";